<template>
  <div class="hello">
    <ClientSelect v-if="signedIn" />
  </div>
</template>

<script>     
import ClientSelect from '@/components/ClientSelect.vue';
import { mapState } from 'vuex'

export default {
  name: 'Home',
  components: {
    ClientSelect,

  },
  computed: mapState([
      'signedIn'
    ]),
  props: {
//    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
